import { CommonErrorStandardsByCode } from "../../../../shared/commontypes";
export function dpTranslateError(code, friendly, remedy) {
    const err = code ? CommonErrorStandardsByCode.get(code) : undefined;
    let translation = friendly + ". " + remedy;
    if (err) {
        translation = translation + ".\n\nAdditional error information: " + err.message;
    }
    else {
        translation = translation + ". In addition, please check your network connectivity";
    }
    translation = translation + ".\n\n If you would like additional support, please contact us at donorservices@kexp.org";
    return (translation);
}
